import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import IOSSwitch from "react-switch";

function SimpleAppBar(props) {
  const tab = '\u00A0';
  return (
    <>
      <div style={{fontWeight: 'bold'}}>
        { props.auth ? 
          (<FormControlLabel style={{float:'right', position: 'relative', zIndex: '1', right: 17, margin:10, fontWeight: 'bold'}} control={<IOSSwitch checked={props.auth} onChange={props.handleChange} />} label={tab+tab+'Menú Visible'}/>):
          (<FormControlLabel style={{float:'right', position: 'relative', zIndex: '1', right: 17, margin:10, fontWeight: 'bold', color: 'red'}} control={<IOSSwitch checked={props.auth} onChange={props.handleChange} />} label={tab+tab+'Menú Oculto'}/>)}
        </div>
    </>
  );
}

export default React.memo(SimpleAppBar);